module.exports = __webpack_public_path__ + "img/account-background.94571bc3.jpg";